module.exports = __webpack_public_path__ + "static/img/ranking3.8e68a44c.png";